import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestModel } from 'src/app/typings/typing';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  prefix = '/user';

  constructor(private http: HttpClient) { }

  
  getRoleList() {
    return this.http.get<RequestModel>('/role/queryAll');
  }
  
  getUser() {
    return this.http.get<RequestModel>(this.prefix + '/queryUserByToken');
  }

  getTableList(params: any) {
    return this.http.post<RequestModel>(this.prefix + '/queryPage', params);
  }

  addOrUpdate(row: any) {
    return this.http.put<RequestModel>(this.prefix + '/update', row);
  }

  delete(id: number | string) {
    return this.http.delete<RequestModel>(this.prefix + `/delete/${id}`);
  }
}
